function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_72",
  x: 0,
  y: 0,
  width: 34,
  height: 34,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_73",
  "data-name": "Ellipse 73",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(0 -0.062)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1919",
  "data-name": "Group 1919",
  transform: "translate(-7 -11)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 7, 11)",
  filter: "url(#Ellipse_72)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_72-2",
  "data-name": "Ellipse 72",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(9 6)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_1",
  "data-name": "Mask Group 1",
  transform: "translate(16 17.062)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "uk",
  transform: "translate(-0.128 -0.062)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_75",
  "data-name": "Ellipse 75",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(0.128)",
  fill: "#f0f0f0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_267",
  "data-name": "Group 267",
  transform: "translate(0.276 0.276)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_167",
  "data-name": "Path 167",
  d: "M10.2,100.142a7.971,7.971,0,0,0-1.378,2.784h4.162Z",
  transform: "translate(-8.819 -97.288)",
  fill: "#0052b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_168",
  "data-name": "Path 168",
  d: "M374.167,102.927a7.972,7.972,0,0,0-1.378-2.784l-2.784,2.784Z",
  transform: "translate(-358.718 -97.289)",
  fill: "#0052b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_169",
  "data-name": "Path 169",
  d: "M8.819,322.784a7.972,7.972,0,0,0,1.378,2.784l2.784-2.784Z",
  transform: "translate(-8.819 -312.973)",
  fill: "#0052b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_170",
  "data-name": "Path 170",
  d: "M325.566,10.2a7.971,7.971,0,0,0-2.784-1.378v4.162Z",
  transform: "translate(-312.971 -8.819)",
  fill: "#0052b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_171",
  "data-name": "Path 171",
  d: "M100.142,372.789a7.972,7.972,0,0,0,2.784,1.378v-4.162Z",
  transform: "translate(-97.288 -358.718)",
  fill: "#0052b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_172",
  "data-name": "Path 172",
  d: "M102.926,8.819a7.972,7.972,0,0,0-2.784,1.378l2.784,2.784Z",
  transform: "translate(-97.288 -8.819)",
  fill: "#0052b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_173",
  "data-name": "Path 173",
  d: "M322.783,374.167a7.972,7.972,0,0,0,2.784-1.378l-2.784-2.784Z",
  transform: "translate(-312.972 -358.718)",
  fill: "#0052b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_174",
  "data-name": "Path 174",
  d: "M370.005,322.784l2.784,2.784a7.972,7.972,0,0,0,1.378-2.784Z",
  transform: "translate(-358.718 -312.973)",
  fill: "#0052b4"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_268",
  "data-name": "Group 268"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_175",
  "data-name": "Path 175",
  d: "M15.932,6.957H9.043V.068a8.073,8.073,0,0,0-2.087,0V6.956H.068a8.073,8.073,0,0,0,0,2.087H6.957v6.889a8.073,8.073,0,0,0,2.087,0V9.044h6.889a8.073,8.073,0,0,0,0-2.087Z",
  fill: "#d80027"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_176",
  "data-name": "Path 176",
  d: "M322.783,322.783h0l3.57,3.57q.246-.246.47-.514l-3.056-3.056h-.984Z",
  transform: "translate(-312.696 -312.696)",
  fill: "#d80027"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_177",
  "data-name": "Path 177",
  d: "M78.55,322.784h0l-3.57,3.57q.246.246.514.47l3.056-3.056Z",
  transform: "translate(-72.637 -312.697)",
  fill: "#d80027"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_178",
  "data-name": "Path 178",
  d: "M63.973,78.55h0L60.4,74.98q-.246.246-.47.514l3.056,3.056h.984Z",
  transform: "translate(-58.06 -72.637)",
  fill: "#d80027"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_179",
  "data-name": "Path 179",
  d: "M322.783,63.974h0l3.57-3.57q-.246-.246-.514-.47l-3.056,3.056Z",
  transform: "translate(-312.696 -58.061)",
  fill: "#d80027"
})))));

var SvgEn = function SvgEn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/en.19f4b758.svg";
export { ForwardRef as ReactComponent };